import { SectionKey } from '../../../../../types';
import { SchemaOrderConfig } from '../../types/form/schema.types';

export const SCHEMA_ORDER: Record<SectionKey, SchemaOrderConfig> = {
  request_reassign: {
    priority: 0, // Highest priority since it can be accessed at any time
    validationOrder: 0,
    calculationOrder: 0,
  },
  rejected_form: {
    priority: -1, // Even higher priority than request_reassign
    validationOrder: -1,
    calculationOrder: -1,
  },
  payment_details: {
    priority: 1,
    validationOrder: 1,
    calculationOrder: 1,
  },
  resp_lawyer: {
    priority: 2,
    dependencies: ['payment_details'],
    validationOrder: 2,
  },
  first_partner: {
    priority: 3,
    dependencies: ['resp_lawyer'],
    validationOrder: 3,
  },
  second_partner: {
    priority: 4,
    dependencies: ['first_partner'],
    validationOrder: 4,
  },
  second_partner_above_25k: {
    priority: 5,
    dependencies: ['second_partner'],
    validationOrder: 5,
  },
  second_partner_below_25k: {
    priority: 6,
    dependencies: ['second_partner'],
    validationOrder: 6,
  },
  payment_hold_review: {
    priority: 7,
    dependencies: ['second_partner'],
    validationOrder: 5,
  },
  payment_confirmation: {
    priority: 8,
    dependencies: ['payment_details', 'second_partner'],
    validationOrder: 6,
    calculationOrder: 2,
  },
  document_saving: {
    priority: 9,
    dependencies: ['payment_confirmation'],
    validationOrder: 7,
  },
  // Dubai Payment From Office Account
  dubai_payment_from_office_account_payment_details: {
    priority: 10,
    validationOrder: 7,
    calculationOrder: 7,
  },
  dubai_payment_from_office_account_approver: {
    priority: 11,
    dependencies: ['dubai_payment_from_office_account_payment_details'],
    validationOrder: 8,
  },
  // Dubai Transfer Requisition
  dubai_transfer_requisition_first_partner: {
    priority: 12,
    validationOrder: 9,
  },
  dubai_transfer_requisition_payment_details: {
    priority: 13,
    dependencies: ['dubai_transfer_requisition_first_partner'],
    validationOrder: 10,
  },
  dubai_transfer_requisition_second_partner: {
    priority: 14,
    dependencies: ['dubai_transfer_requisition_first_partner'],
    validationOrder: 11,
  },
  dubai_transfer_requisition_payment_confirmation: {
    priority: 15,
    dependencies: ['dubai_transfer_requisition_second_partner'],
    validationOrder: 12,
  },
  dubai_payment_from_office_account_payment_confirmation: {
    priority: 16,
    dependencies: ['dubai_payment_from_office_account_payment_details'],
    validationOrder: 13,
  },
  // Overtime Approval
  overtime_approval_request_details: {
    priority: 17,
    validationOrder: 14,
    calculationOrder: 14,
  },
  overtime_approval_line_manager: {
    priority: 18,
    dependencies: ['overtime_approval_request_details'],
    validationOrder: 15,
  },
  overtime_approval_finance_confirmation: {
    priority: 19,
    dependencies: ['overtime_approval_line_manager'],
    validationOrder: 16,
  },
};
